export const actionTypes = {
  ACTIVITY_CREATE: "activity/create",

  PATIENT_ABSENCES_CREATE: "patientAbsences/create",
  PATIENT_ABSENCES_UPDATE: "patientAbsences/update",
  PATIENTS: "patients",
  EDITOR: "editor",
  ACTIVITIES_EDIT_LOG: "app.activities.edit_log",
  ACTIVITIES_EDIT_TASK: "app.activities.edit_task",
  ACTIVITIES_EDIT_EVENT: "app.activities.edit_event",
};

export const activityStatuses = {
  ACTIVITIES_STATUS_COMPLETAED: "completed",
};

export const activityTypes = {
  ACTIVITIES_TYPE_CALL: "call",
  ACTIVITIES_TYPE_TASKS: "tasks",
  ACTIVITIES_TYPE_TASK: "task",
  ACTIVITIES_TYPE_MAIL: "mail",
};

export const activityPriorities = {
  ACTIVITIES_PRIORITY_NORMAL: "normal",
};
